import { __assign, __extends, __rest } from "tslib";
import React from 'react';
import { SettingsTabLayoutContext } from '../SettingsTabLayoutContext';
var lifecycleProps = [
    'automationId',
    'dataHook',
    'title',
    'id',
    'articleId',
    'className',
    'showDotIndicator',
    'children',
    // 'Component',
];
var _Tab = /** @class */ (function (_super) {
    __extends(_Tab, _super);
    function _Tab() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    _Tab.prototype.componentDidMount = function () {
        var _a = this.props, addTab = _a.addTab, props = __rest(_a, ["addTab"]);
        var _b = addTab({ type: 0 /* Tab */, props: props }), removeTab = _b.removeTab, updateTab = _b.updateTab;
        this.removeTab = removeTab;
        this.updateTab = updateTab;
    };
    _Tab.prototype.componentWillUnmount = function () {
        if (this.removeTab) {
            this.removeTab();
        }
    };
    _Tab.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, addTab = _a.addTab, props = __rest(_a, ["addTab"]);
        if (this.updateTab &&
            lifecycleProps.some(function (prop) { return props[prop] !== prevProps[prop]; })) {
            this.updateTab({ type: 0 /* Tab */, props: props });
        }
    };
    _Tab.prototype.render = function () {
        return null;
    };
    return _Tab;
}(React.Component));
export var Tab = function (props) {
    return (React.createElement(SettingsTabLayoutContext.Consumer, null, function (context) { return React.createElement(_Tab, __assign({}, props, { addTab: context.addTab })); }));
};
//# sourceMappingURL=Tab.js.map